import { transformImageUrl } from '@kontent-ai/delivery-sdk'
import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (src, { modifiers = {}, baseURL } = {}) => {
  const width = Number(modifiers?.width || 0)
  const height = Number(modifiers?.height || 0)
  const imageBuilder = transformImageUrl(src)
    .withAutomaticFormat()
    .withCompression('lossless')
    .withHeight(height)
    .withWidth(width)

  const transformedUrl = imageBuilder.getUrl()

  return {
    url: transformedUrl
  }
}
